import React, { useEffect, useState } from 'react'
import { Box } from "@mui/material";
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import { ActionPermission, PageInfo } from '../PageInfo';
import AppbarComponent from '../../Services/AppbarComponent';
import Button from "react-bootstrap/Button";
import Alert from '@mui/material/Alert';
import { StandardConst } from '../../Services/StandardConst';
import { Form, FormAutoCompleteDropdownCard, FormInputText } from '../Form';
import * as yup from "yup";
import { WebService } from '../../Services/WebService';
import { useDispatch, useSelector } from 'react-redux';
import { WSSuccessAlert, WSErrorAlert } from '../../Services/WSAlert';
import { Card } from "react-bootstrap";





const ResetEmployeePasswords = () => {

    const dispatch = useDispatch();
    const CompanyInfo = useSelector(s => s.auth.CompanyInfo ?? {});
    const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
    const [permission, SetPermission] = useState({});
    useEffect(() => {
        SetPermission({
        ManageReset: ActionPermission("Employee-reset-password-all"),
        });
    }, [permissionList]);

    const [bData] = React.useState([
        {
            title: "Administration",
            hrefLink: "#",
        },
        {
            title: "Reset Employee Password",
            hrefLink: "#",
        },
    ]);

    const MasterPageName = "Reset Employee Password";
    PageInfo({ pageTitle: "Reset Employee Password" });

    const [employeeList, setEmployeeList] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [dropdownKey, setDropdownKey] = useState(0);

    const schema = yup.object().shape({
        Employee: yup
            .array()
            .of(
                yup.object().shape({
                    heading: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
                })
            )
            .typeError(StandardConst.ValidationMessages.RequiredFieldMsg)
            .min(1, StandardConst.ValidationMessages.RequiredFieldMsg),

        NewPassword: yup
            .string()
            .min(6, 'Password must be at least 6 characters')
            .required(StandardConst.ValidationMessages.RequiredFieldMsg),

        ConfirmPassword: yup
            .string()
            .oneOf([yup.ref('NewPassword')], 'Passwords do not match')
            .required(StandardConst.ValidationMessages.RequiredFieldMsg),
    }).required();

    const fetchAllEmployees = async () => {
        try {
            const employees = await WebService({
                endPoint: `Visitor/fetchAllEmployees`,
                dispatch,
            });

            const empList = employees
                ?.filter((r) => r.FullName !== null)
                ?.map((res) => ({
                    ...res,
                    EmployeeId: res.EmployeeId,
                    heading: res.FullName,
                    description: res?.Designation || 'Employee',
                    avatar: `${StandardConst.apiBaseUrl}/uploads/${res.ProfileImage}`,
                }));

            setEmployeeList(empList);
        } catch (error) {
            console.error('Error fetching employees:', error);
        } finally {
            setIsDataLoaded(true);
        }
    };

    useEffect(() => {
        fetchAllEmployees();
    }, []);

    const onSubmit = async (data,methods) => {
        if (!selectedEmployee) {
            WSErrorAlert('', 'Please select an Employee');
            return;
        }

        await WebService({
            endPoint: "LogIn/ResetEmployeePassword",
            body: {
                EmployeeId: selectedEmployee.EmployeeId,
                CompanyId: CompanyInfo?.CompanyId,
                NewPassword: data.NewPassword,
            },
            dispatch,
        }).then((res) => {
            if (res.success === "true") {
                WSSuccessAlert("", res.message);
                methods.reset();   // ✅ SIMPLE RESET
                setSelectedEmployee(null);
                setDropdownKey(prev => prev + 1);  // 🔥 force remount dropdown
            } else {
                WSErrorAlert("", res.message);
            }
        });
    };

    if (!isDataLoaded) {
        return <></>;
    }

    return (
        <>
         {permission.ManageReset ? (
            <div className="base-container">
                <Box sx={{ width: 1 }}>
                    <h5 className="ms-4 mt-2">{MasterPageName}</h5>
                    <div className="ms-4">
                        <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
                    </div>
                </Box>
                <AppbarComponent
                    title={MasterPageName}
                    isSearchRequired={false}
                    isAddButtonRequired={false}
                    Exception={true}
                />
                <div className="row p-0 mb-2 d-flex flex-row">
                    <div className="col-md-12">
                        <Alert severity="info" sx={{ width: "100%" }}>Reset Employee Password</Alert>
                    </div>
                </div>
                <div className="row p-0 mb-2 d-flex flex-row">
                    <div className="col-md-8">
                        <div>
                            <Form
                                defaultValues={{}}
                                // onSubmit={onSubmit}
                                onSubmit={(data, methods) => onSubmit(data, methods)}
                                validationSchema={schema}
                            >
                                <div className="card shadow-none border-0 border-start footer-widget mt-2 ms-2">
                                    
                                    <div className="card-body">
                                        <div className="row mt-1">
                                            <div className="row">

                                                <div className="col-md-12 mb-2">
                                                    <FormAutoCompleteDropdownCard
                                                     key={dropdownKey}
                                                        name="Employee"
                                                        data={employeeList ?? []}
                                                        label="Employee"
                                                        optionText="heading"
                                                        isRequired="true"
                                                        setValue={(v) => {
                                                            setSelectedEmployee(v[0] ?? null);
                                                        }}
                                                        value={selectedEmployee ? [selectedEmployee] : []}
                                                    />
                                                </div>

                                                <div className="col-md-12">
                                                    <FormInputText
                                                        label="New Password"
                                                        name="NewPassword"
                                                        type="password"
                                                        isRequired="true"
                                                    />
                                                </div>

                                                <div className="col-md-12 mt-2">
                                                    <FormInputText
                                                        label="Confirm Password"
                                                        name="ConfirmPassword"
                                                        type="password"
                                                        isRequired="true"
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <Button
                                                variant="outline-primary"
                                                type="submit"
                                                id="btnSubmit"
                                                className="px-4 float-end mt-4 mb-1"
                                                style={{ marginRight: "27px" }}
                                            >
                                                Reset Password
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
         ): (
      <Card className="shadow-sm mt-4 container">
        <Card.Body className="text-center p-4">
          <h5 className="text-danger mb-2">Access Denied</h5>
          <p className="text-muted mb-0">
            You do not have permission to view this page.
            Please contact your administrator.
          </p>
        </Card.Body>
      </Card>
    )}
        </>
    );
};

export default ResetEmployeePasswords;